import React from "react";
import { useTranslation } from "react-i18next";
import ProblematicItemsWarningModal, { isProblematicItemsWarning } from "./ProblematicItemsWarningModal";
import { CheckoutOrderViewItem } from "./checkoutOrderView";
import currencyFormatter, { Currency } from "@/common/CurrencyFormatter";

interface BasketTotalAmountBlockProperties {
    readonly itemsAmount: number;
    readonly items: CheckoutOrderViewItem[];
    readonly checkoutUrl: string;
    readonly currency: Currency;
}

export default function BasketTotalAmountBlock({
    itemsAmount,
    items,
    checkoutUrl,
    currency,
}: BasketTotalAmountBlockProperties): React.JSX.Element {
    const [shownProblematicItemsWarning, setShownProblematicItemsWarning] = React.useState(false);

    const { t } = useTranslation("basket");

    return (
        <div id="totalPriceBlockContainer" className="col-sm-3 basket-summary-block">
            <table className="table table-lined cart-table new-step1-total">
                <tbody>
                    <tr className="noborder cart-row cart-total">
                        <td>
                            <div className="cart-total-inner">
                                <div className="cart-right">
                                    <span>{t("total")}</span>
                                    <span>{currencyFormatter.formatCurrencyWithSymbol(itemsAmount, currency)}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="buttons cart-button new-step1-continue-bottom">
                {isProblematicItemsWarning(items)
                    ? <a
                        href="#"
                        onClick={(event) => {
                            event.preventDefault();
                            setShownProblematicItemsWarning(true);
                        }}
                        className="btn btn-xlg pull-right">{t("proceedToCheckout")}</a>
                    : <a
                        href={checkoutUrl}
                        className="btn btn-xlg pull-right">{t("proceedToCheckout")}
                    </a>}
            </div>

            <div className="new-step1-karel">
                <img src="/css/image/karel_mava.gif" alt="" className="img-responsive" />
            </div>
            {shownProblematicItemsWarning && <ProblematicItemsWarningModal
                checkoutUrl={checkoutUrl}
                onClose={() => setShownProblematicItemsWarning(false)}
                items={items} />}
        </div>
    );
}
